import { render, staticRenderFns } from "./SettingsSection.vue?vue&type=template&id=55021144&"
import script from "./SettingsSection.vue?vue&type=script&lang=ts&"
export * from "./SettingsSection.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports